import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useLoad } from "@redotech/react-util/load";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { templateTypeLabel } from "@redotech/redo-model/email-builder";
import { SendSmsState } from "@redotech/redo-return-ui/flows/return-flow/send-sms";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Link } from "@redotech/redo-web/link";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { Spinner, SpinnerStyle } from "@redotech/redo-web/spinner";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as selectCss from "./select.module.css";

export const SendSmsDetails = memo(function SendSmsDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<SendSmsState>) {
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const smsLoad = useLoad(async () => {
    const templates = await marketingRpcClient.paginateSmsTemplates({
      page: 1,
      pageSize: 1000,
    });
    return templates;
  }, []);
  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });

  return (
    <>
      <Flex align="center" gap="xs">
        <Text fontSize="xs" textColor="secondary">
          SMS template -
        </Text>
        <Link to="../../sms-templates">Create new</Link>
      </Flex>
      {smsLoad.value ? (
        <SelectDropdown
          disabled={!smsLoad.value}
          options={smsLoad.value.data || []}
          value={smsLoad.value.data?.find(
            (template: any) => template._id === state.smsId,
          )}
          valueChange={(e: any) =>
            setState((state) => ({
              ...state,
              smsId: e._id,
              smsName: e.name,
              smsType: e.templateType,
            }))
          }
        >
          {(type) => (
            <div className={selectCss.value}>
              <div className={selectCss.title}>{`${type.name}${
                type.templateType
                  ? ` - ${templateTypeLabel(type.templateType)}`
                  : ""
              }`}</div>
            </div>
          )}
        </SelectDropdown>
      ) : (
        <div style={{ width: "21px", marginLeft: "auto", marginRight: "auto" }}>
          <Spinner style={SpinnerStyle.AUTO} />
        </div>
      )}
      <Text fontSize="xs" textColor="secondary">
        Next step
      </Text>
      {stepSelect({ value: state.next, valueChange: nextStepChange })}
    </>
  );
});
